// src/features/chat/components/his/ArtifactMetaLine.jsx
import React from 'react';
import styles from '../../styles/HisArtifact.module.css';

/**
 * Small self-identifying meta line every artifact opens with (who, when),
 * legible with or without neighboring messages.
 */
export function ArtifactMetaLine({ botName, timeMs }) {
  const timeText = timeMs > 0
    ? new Date(timeMs).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
    : null;
  return (
    <div className={styles.metaLine}>
      <b>{botName}</b>
      {timeText && <span>{timeText}</span>}
    </div>
  );
}

export default ArtifactMetaLine;
